import PropTypes from 'prop-types';
import { Box, Dialog, Typography, useTheme } from '@mui/material';
import { useState, createContext, useContext } from 'react';
import Button from './Button';
import FilterRail from './FilterRail';
import { FilterIcon } from '../assets/icons/icons';

const MobileDialogContext = createContext({
  onClose: () => void 0,
});

function MobileDialog({ children, title, variant = 'sticky' }) {
  const theme = useTheme();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <MobileDialogContext.Provider value={{ onClose: () => setIsDialogOpen(false) }}>
      {variant === 'sticky' && (
        <Button
          onClick={() => setIsDialogOpen(true)}
          sx={{
            position: 'fixed',
            bottom: 20,
            right: 20,
            display: { xs: 'block', md: 'none' },
            height: 56,
            width: 56,
            backgroundColor: 'orange.500',
            borderRadius: '50%',
            minWidth: 'auto',
            textTransform: 'none',
            boxShadow: theme.shadows[10],
            '&:hover': {
              backgroundColor: 'orange.300',
            },
          }}
        >
          <Typography variant="body3" color="common.black" fontWeight="bold">
            {title}
          </Typography>
        </Button>
      )}

      {variant === 'static' && (
        <Button
          sx={{ display: 'flex', alignItems: 'center', minWidth: 'auto', py: 0.5 }}
          onClick={() => setIsDialogOpen(true)}
        >
          <FilterIcon />
          <Typography
            fontSize="0.875rem"
            textTransform="uppercase"
            ml={1.5}
            color="common.black"
            fontWeight="bold"
          >
            {title}
          </Typography>
        </Button>
      )}

      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        fullScreen
        aria-labelledby="filter-rail-heading"
      >
        {children}
      </Dialog>
    </MobileDialogContext.Provider>
  );
}

MobileDialog.displayName = 'MobileDialog';

MobileDialog.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node,
};

export default MobileDialog;

export const useMobileDialog = () => useContext(MobileDialogContext);
